export default __webpack_public_path__ + "static/media/Hap.4a5918d1.jfif";